import type { Control, ControlSelections } from '../../types/controls';

/** Changing a control invalidates everything transitively downstream of it (A -> B -> C). */
export const withDependentsCleared = (
  selections: ControlSelections,
  changedKey: string,
  controls: Control[],
): ControlSelections => {
  const next = { ...selections };
  const stale = new Set<string>([changedKey]);
  for (let added = true; added; ) {
    added = false;
    for (const control of controls) {
      if (!stale.has(control.key) && control.dependsOn?.some((parent) => stale.has(parent))) {
        stale.add(control.key);
        delete next[control.key];
        added = true;
      }
    }
  }
  return next;
};
